import { Popover } from "antd";
import React, { useEffect, useState } from "react";
import { AppDispatch, RootState } from "../../../redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import filterIcon from "../assets/filter-2.svg";
import Drop from "../assets/Polygon 2.svg";
import UserExtensiveSearch from "./UserExtensiveSearch";
import { UserControlSlices } from "../../../slices/UserControlSlice";
import { GetAllUser } from "../../../api/ssoapi/UserControlapi";
import { ESearchFilterActiveTypes } from "../../../constants/CommonInterfaces";

interface IUserFilter {
  searchField?: string;
  accessorKey: string;
  isFilter?: boolean;
}

export const userDBTilte = {
  userName: "UserName",
  email: "Email",
  ssoRoles: "SSORoles",
  accessApplications: "AccessApplications.ApplicationID",
  accountStatus: "UserAccount.Account",
  otp: "IsOtpEnabled",
  ccEmailIds: "CCEmailIds",
};

export interface IKeyValuePair {
  label: string;
  value: string;
}

export const accessApplications: IKeyValuePair[] = [
  { label: "CTC", value: "9b697193-ded3-4716-9666-f2d24f5ae7f8" },
  { label: "CCT", value: "444c94ac-fdb6-4d3f-9992-7c1abfbc48ac" },
  { label: "Reports", value: "555594ac-fdb6-4d3f-9992-7c1abfbc48ac" },
  // { label: "Sso", value: "555594ac-fdb6-4d3f-9992-7c1abfbc48ac" },
];
export const otp: IKeyValuePair[] = [
  { label: "Enabled", value: "true" },
  { label: "Disabled", value: "false" },
];
export const accountStatus: IKeyValuePair[] = [
  { label: "Locked", value: "LOCK" },
  { label: "Active", value: "UNLOCK" },
];

export const ssoRoles: IKeyValuePair[] = [
  { label: "PCG Admin", value: "SSO_ADMIN" },
  { label: "PCG Broadcast Manger", value: "SSO_BROADCAST_MANAGER" },
];

const UserFilter: React.FC<IUserFilter> = ({
  accessorKey,
  searchField,
  isFilter,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { searchFilter } = useSelector((state: RootState) => state.userControl);

  // Popover visibility state
  const [isPopoverVisible, setIsPopoverVisible] = useState<boolean>(false);
  const [isEnableSearch, setIsEnableSearch] = useState<boolean>(false);
  const [otpIsToggle, setOtpIsToggle] = useState<boolean>(false);
  const [accountStatusIsToggle, setAccountStatusIsToggle] =
    useState<boolean>(false);
  const [ssoRolesIsToggle, setSsoRolesIsToggle] = useState<boolean>(false);
  const [accessApplicationIsToggle, setAccessApplicationIsToggle] =
    useState<boolean>(false);

  // set the state Dropdown toggle
  const handleToggleDropDown = (field: string) => {
    if (field === "otp") {
      setOtpIsToggle(!otpIsToggle);
    } else if (field === "accountStatus") {
      setAccountStatusIsToggle(!accountStatusIsToggle);
    } else if (field === "ssoRoles") {
      setSsoRolesIsToggle(!ssoRolesIsToggle);
    } else if (field === "accessApplications") {
      setAccessApplicationIsToggle(!accessApplicationIsToggle);
    }
  };

  // Common handler for opening filter popover
  const handleFilterClick = () => {
    setIsPopoverVisible(!isPopoverVisible);
  };

  // Common handler for closing filter popover
  const handleFilterClose = () => {
    setIsPopoverVisible(false);
  };

  // Generic input change handler for base filter
  const handleFilterInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    localField: string
  ) => {
    setIsEnableSearch(false);
    dispatch(
      UserControlSlices.UpdateLocalSearchQuery({
        field: localField,
        value: event.target.value,
      })
    );
  };

  // handle changes for category and status
  const handleDropDownChanges = (item: IKeyValuePair, field: string): void => {
    setIsEnableSearch(false);
    if (field === "otp") {
      dispatch(
        UserControlSlices.UpdateLocalSearchQuery({
          field: field,
          value: item.value,
        })
      );
      setOtpIsToggle(false);
    } else if (field === "accountStatus") {
      dispatch(
        UserControlSlices.UpdateLocalSearchQuery({
          field: field,
          value: item.value,
        })
      );
      setAccountStatusIsToggle(false);
    } else if (field === "ssoRoles") {
      dispatch(
        UserControlSlices.UpdateLocalSearchQuery({
          field: field,
          value: item.value,
        })
      );
      setSsoRolesIsToggle(false);
    } else if (field === "accessApplications") {
      dispatch(
        UserControlSlices.UpdateLocalSearchQuery({
          field: field,
          value: item.value,
        })
      );
      setAccessApplicationIsToggle(false);
    }
  };

  useEffect(() => {
    if (isEnableSearch) {
      //Removing the empty value field
      let lSearchQuery = Object.assign({}, searchFilter.apiQuery);
      lSearchQuery.isOr = false;
      lSearchQuery.page = 1;
      dispatch(
        UserControlSlices.UpdatePagination({
          page: 1,
          pageSize: searchFilter.apiQuery.pageSize,
          isPageChanged: false,
        })
      );
      dispatch(
        UserControlSlices.UpdateGlobalSearchFilter({
          value: "",
        })
      );

      dispatch(UserControlSlices.UpdateGlobalSearchFilterActive());
      dispatch(
        UserControlSlices.UpdateLastActiveSearch({
          value: ESearchFilterActiveTypes.column,
        })
      );
      dispatch(GetAllUser(lSearchQuery));
      setIsEnableSearch(false);
      handleFilterClose();
    }
  }, [isEnableSearch]);

  // Apply filter based on accessor key
  const handleApplyFilter = () => {
    // Apply temp search values to actual search query
    dispatch(UserControlSlices.ApplyColumnSearchFilter());
    setIsEnableSearch(true);
  };

  // clear function for cloumn search
  const handleToClear = (field: string): void => {
    setIsEnableSearch(false);
    dispatch(
      UserControlSlices.ResetColumnSearchFilter({
        canClearAll: false,
        fieldClear: field,
      })
    );
    let lSearchQuery = Object.assign({}, searchFilter.apiQuery);
    lSearchQuery.filters = lSearchQuery.filters.filter(
      (x) => x.field !== userDBTilte[field as keyof typeof userDBTilte]
    );
    lSearchQuery.isOr = false;
    lSearchQuery.page = 1;
    dispatch(
      UserControlSlices.resetLocalSearchQuery({
        canClearAll: false,
        fieldClear: field,
      })
    );
    dispatch(
      UserControlSlices.UpdateGlobalSearchFilter({
        value: "",
      })
    );

    dispatch(UserControlSlices.UpdateGlobalSearchFilterActive());
    dispatch(GetAllUser(lSearchQuery));
    handleFilterClose();
  };

  // Render filter content based on accessor key
  const renderFilterContent = () => {
    switch (accessorKey) {
      case "userName":
      case "email":
      case "ccEmailIds":
        return (
          <div className="user-filter-container">
            <div className="filter-box-header">{searchField}</div>
            <input
              placeholder={`Enter ${searchField}`}
              value={searchFilter.columnSearch[accessorKey].value}
              onChange={(e) => handleFilterInputChange(e, accessorKey)}
              className="filter-box-input"
            />
            <div className="column-filter-button-div">
              <button
                className="column-filter-clear-btn"
                onClick={() => handleToClear(accessorKey)}
              >
                Clear
              </button>
              <button
                onClick={handleApplyFilter}
                className="popup-create-btn column-filter-search-btn"
              >
                Search
              </button>
            </div>
          </div>
        );
      case "ssoRoles":
      case "otp":
      case "accountStatus":
      case "accessApplications":
        return (
          <div className="user-filter-container">
            <div className="filter-box-header">{searchField}</div>
            <div className="input-subContainer">
              <div
                className="dropdow-input-container"
                onClick={() => handleToggleDropDown(accessorKey)}
              >
                <span
                  className="dropdown-spanElement"
                  style={{ fontSize: "10px" }}
                >
                  {searchFilter.columnSearch[accessorKey].value !== ""
                    ? (() => {
                        const optionsMap = {
                          ssoRoles: ssoRoles,
                          otp: otp,
                          accountStatus: accountStatus,
                          accessApplications: accessApplications,
                        };

                        const options =
                          optionsMap[accessorKey as keyof typeof optionsMap];
                        return (
                          options.find(
                            (item) =>
                              item.value ===
                              searchFilter.columnSearch[accessorKey].value
                          )?.label || "Select Option"
                        );
                      })()
                    : "Select Option"}
                </span>
                <img src={Drop} alt="" />
              </div>
            </div>
            {(() => {
              const toggleMap = {
                ssoRoles: ssoRolesIsToggle,
                otp: otpIsToggle,
                accountStatus: accountStatusIsToggle,
                accessApplications: accessApplicationIsToggle,
              };

              const optionsMap = {
                ssoRoles: ssoRoles,
                otp: otp,
                accountStatus: accountStatus,
                accessApplications: accessApplications,
              };

              const isToggle = toggleMap[accessorKey as keyof typeof toggleMap];
              const options =
                optionsMap[accessorKey as keyof typeof optionsMap];

              return isToggle ? (
                <div className="category-dropDown-container">
                  {options.map((item: any) => (
                    <div
                      key={item.value}
                      className="filter-box-list-item"
                      onClick={() => handleDropDownChanges(item, accessorKey)}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              ) : null;
            })()}
            <div className="column-filter-button-div">
              <button
                className="column-filter-clear-btn"
                onClick={() => handleToClear(accessorKey)}
              >
                Clear
              </button>
              <button
                onClick={handleApplyFilter}
                className="popup-create-btn column-filter-search-btn"
              >
                Search
              </button>
            </div>
          </div>
        );
      case "ExtensiveSearch":
        return <UserExtensiveSearch onClose={handleFilterClose} />;
      default:
        return null;
    }
  };

  // Render filter icon based on accessor key
  const renderFilterIcon = () => {
    switch (accessorKey) {
      case "ExtensiveSearch":
        return (
          <button className="filter-button">
            <img src={filterIcon} alt="filter" />
            Filter
          </button>
        );
      default:
        return (
          <button
            className="column-filter-button"
            onClick={() => handleFilterClick()}
          >
            <FilterAltIcon
              className="column-filter-icon"
              style={{
                backgroundColor: isFilter ? "#fff" : "",
                color: isFilter ? "#ec6c2a" : "",
              }}
            />
          </button>
        );
    }
  };

  return (
    <Popover
      content={
        <div className="column-filter-container">{renderFilterContent()}</div>
      }
      trigger="click"
      open={isPopoverVisible}
      onOpenChange={(visible) => setIsPopoverVisible(visible)}
      placement={accessorKey === "ExtensiveSearch" ? "bottomRight" : "bottom"}
    >
      {renderFilterIcon()}
    </Popover>
  );
};

export default UserFilter;
